import ramatechLogo from "../../../asset/images/Ramatech LOGO.png";

export const RAMATECH_BRAND = {
  companyName: "Ramatech",
  logo: ramatechLogo,
};
